/* eslint-disable no-param-reassign */
import produce from "immer";
import {
	SET_AUDIPHONE,
	SET_AUDIPHONE_SETTING,
	SET_PATIENT,
	SET_ACOUSTICS_CHART_DATA,
	SET_ACOUSTICS_CHART_SETTING,
	SET_ALL_ACOUSTICS_CHART_SETTING,
	SET_ADJUST_TYPE,
	SET_SHOW_GAIN_THRESHOLD,
	SET_ADJUST_TYPE_IN_TYPE,
	SET_IO_RATE,
	SET_GAIN_CHART_POINTS,
	SET_OPEN_SOUND_RECOVER_2,
	SET_OPEN_SOUND_RECOVER_RATE_RANGE,
	SET_USER_NOISE_GENERATOR,
	SET_FEEDBACK_REALEARTEST_OVERTUNING,
	SET_SESSIONS,
	SET_ALL_CHART,
	SET_HI_CONFIGURATION,
	SET_HI_DETAIL,
	SET_HI_IMAGE,
	CLEAR_PATIENT,
	SET_DETAIL_COLOR_VALUE
} from "src/actions/patientActions";
import {
	GetTestData,
	GetTestIOData,
	TestData,
	TestIOData,
	TestNoiseData,
	TestRatioData
} from "src/utils/test";

const cachePaitentJSON = localStorage.getItem("patientId");

const initialState = {
	patient: cachePaitentJSON ? JSON.parse(cachePaitentJSON) : null,
	sessionList: [],
	hearingDeviceLeft: null,
	hearingDeviceSettingLeft: null,
	hearingDeviceRight: null,
	hearingDeviceSettingRight: null,
	hiConfiguration: null,
	hiDetail: null,
	audiogramIds: [],
	acousticsChartDataLeft: [
		// [
		//   {
		//     name: 'AC',
		//     lineColor: '#006eae',
		//     pointStyle: 'AirCoupledRegularLeft',
		//     isEditable: true,
		//     points: [{ x: 250, y: 40 }, { x: 1000, y: 50 }, { x: 3000, y: 70 }]
		//   },
		//   {
		//     name: 'BC',
		//     lineColor: '#006eae',
		//     pointStyle: 'BoneCoupledRegularLeft',
		//     isEditable: true,
		//     points: [{ x: 250, y: 10 }, { x: 1000, y: 60 }, { x: 3000, y: 80 }]
		//   },
		//   {
		//     name: 'UCL',
		//     lineColor: '#006eae',
		//     pointStyle: 'UclRegularLeft',
		//     isEditable: true,
		//     points: [{ x: 250, y: 20 }, { x: 1000, y: 10 }, { x: 3000, y: 10 }]
		//   }
		// ],
		// [
		//   {
		//     name: '输入的',
		//     lineColor: '#006eae',
		//     isCurve: true,
		//     pointStyle: 'circle',
		//     isEditable: true,
		//     points: [{ x: 250, y: 30 }, { x: 750, y: 20 }, { x: 1500, y: -20 }, { x: 6000, y: 35 }]
		//   },
		//   // {
		//   //   name: '预估的',
		//   //   lineColor: '#ABABAB',
		//   //   isCurve: true,
		//   //   isEditable: false,
		//   //   pointStyle: 'none',
		//   //   lineStyle: 'solid',
		//   //   points: [{ x: 250, y: 80 }, { x: 1000, y: 20 }, { x: 6000, y: 40 }]
		//   // }
		//   // ,
		//   // {
		//   //   name: '平均的',
		//   //   lineColor: '#ABABAB',
		//   //   isCurve: true,
		//   //   isEditable: false,
		//   //   lineStyle: 'dash',
		//   //   pointStyle: 'none',
		//   //   points: [{ x: 250, y: 10 }, { x: 750, y: 0 }, { x: 8000, y: -10 }]
		//   // }
		// ],
		// [
		//   {
		//     name: '输入的',
		//     lineColor: '#006eae',
		//     pointStyle: 'circle',
		//     lineStyle: 'solid',
		//     isCurve: true,
		//     isEditable: true,
		//     points: [{ x: 250, y: 30 }, { x: 750, y: 20 }, { x: 8000, y: 0 }]
		//   },
		//   // {
		//   //   name: '平均的',
		//   //   lineColor: '#ABABAB',
		//   //   isCurve: true,
		//   //   isEditable: false,
		//   //   lineStyle: 'dash',
		//   //   pointStyle: 'none',
		//   //   points: [{ x: 125, y: 60 }, { x: 750, y: 55 }, { x: 4000, y: 50 }, { x: 8000, y: 55 }]
		//   // }
		// ]
	],
	acousticsChartDataRight: [
		// [
		//   {
		//     name: 'AC',
		//     lineColor: '#c91a22',
		//     pointStyle: 'AirCoupledRegularRight',
		//     isEditable: true,
		//     points: [{ x: 250, y: 40 }, { x: 1000, y: 50 }, { x: 3000, y: 70 }]
		//   },
		//   {
		//     name: 'BC',
		//     lineColor: '#c91a22',
		//     pointStyle: 'BoneCoupledRegularRight',
		//     isEditable: true,
		//     points: [{ x: 250, y: 10 }, { x: 1000, y: 60 }, { x: 3000, y: 80 }]
		//   },
		//   {
		//     name: 'UCL',
		//     lineColor: '#c91a22',
		//     pointStyle: 'UclRegularRight',
		//     isEditable: true,
		//     points: [{ x: 250, y: 20 }, { x: 1000, y: 10 }, { x: 3000, y: 10 }]
		//   }
		// ],
		// [
		//   {
		//     name: '输入的',
		//     lineColor: '#c91a22',
		//     isEditable: true,
		//     isCurve: true,
		//     pointStyle: 'circle',
		//     points: [{ x: 250, y: 20 }, { x: 750, y: 25 }, { x: 1500, y: -20 }, { x: 6000, y: -30 }]
		//   },
		//   // {
		//   //   name: '预估的',
		//   //   lineColor: '#ABABAB',
		//   //   isCurve: true,
		//   //   isEditable: false,
		//   //   pointStyle: 'none',
		//   //   lineStyle: 'solid',
		//   //   points: [{ x: 125, y: 55 }, { x: 750, y: 65 }, { x: 4000, y: 55 }, { x: 8000, y: 50 }]
		//   // }
		//   // ,
		//   // {
		//   //   name: '平均的',
		//   //   lineColor: '#ABABAB',
		//   //   isCurve: true,
		//   //   isEditable: false,
		//   //   lineStyle: 'dash',
		//   //   pointStyle: 'none',
		//   //   points: [{ x: 125, y: 0 }, { x: 750, y: 20 }, { x: 4000, y: -10 }, { x: 8000, y: -20 }]
		//   // }
		// ],
		// [
		//   {
		//     name: '输入的',
		//     lineColor: '#006eae',
		//     pointStyle: 'circle',
		//     lineStyle: 'solid',
		//     isCurve: true,
		//     isEditable: true,
		//     points: [{ x: 250, y: 10 }, { x: 750, y: 0 }, { x: 8000, y: -10 }]
		//   },
		//   // {
		//   //   name: '平均的',
		//   //   lineColor: '#ABABAB',
		//   //   isCurve: true,
		//   //   isEditable: false,
		//   //   lineStyle: 'dash',
		//   //   pointStyle: 'none',
		//   //   points: [{ x: 125, y: 60 }, { x: 750, y: 55 }, { x: 4000, y: 50 }, { x: 8000, y: 55 }]
		//   // }
		// ]
	],
	acousticsChartSettingLeft: [
		{
			date: new Date(),
			device: "",
			frequency: "",
			loudness: "",
			THI: "",
			radio: "diagram"
		},
		{
			date: new Date(),
			device: "",
			radio: "input"
		},
		{
			date: new Date(),
			device: "",
			radio: "input"
		}
	],
	acousticsChartSettingRight: [
		{
			date: new Date(),
			device: "headwear",
			frequency: "",
			loudness: "",
			THI: 12,
			radio: "diagram"
		},
		{
			date: new Date(),
			device: "foam-earplugs-HA-1",
			radio: "input"
		},
		{
			date: new Date(),
			device: "0-trumpet",
			radio: "input"
		}
	],
	historyList: [],
	hearinginstrumentAdjustmentData: {
		type: "Gain",
		Gain: {
			type: "insertGain",
			insertGain: {
				leftData: [...TestData],
				rightData: [...GetTestData()]
			},
			realEar: {
				leftData: [...GetTestData()],
				rightData: [...GetTestData()]
			},
			"2cc": {
				leftData: [...GetTestData()],
				rightData: [...GetTestData()]
			},
			show: false
		},
		Output: {
			type: "HL",
			HL: {
				leftData: [...GetTestData()],
				rightData: [...GetTestData()]
			},
			splRealEar: {
				leftData: [...GetTestData()],
				rightData: [...GetTestData()]
			},
			spl2cc: {
				leftData: [...GetTestData()],
				rightData: [...GetTestData()]
			},
			showLevel: false,
			showVoice: false,
			showActual: false
		},
		InputOutput: {
			type: "splRealEar",
			splRealEar: {
				leftData: [...TestIOData],
				rightData: [...GetTestIOData()]
			},
			spl2cc: {
				leftData: [...GetTestIOData()],
				rightData: [...GetTestIOData()]
			},
			rate: 125
		},
		GainCompression: {
			leftData: [...TestRatioData],
			rightData: [...TestRatioData]
		}
	},
	hearinginstrumentFineAdjustmentData: {
		left: {
			openSoundRecover2: false,
			useNoiseGenerator: false,
			noiseData: TestNoiseData,
			range: [7000, 7700, 8900]
		},
		right: {
			openSoundRecover2: false,
			useNoiseGenerator: false,
			noiseData: TestNoiseData,
			range: [7000, 7700, 8900]
		}
	},
	feedbackRealEarTest: {
		left: {
			overtuning: 0
		},
		right: {
			overtuning: 0
		}
	}
};

const patientReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SESSIONS: {
			const { sessions } = action.payload;

			return produce(state, draft => {
				draft.sessionList = sessions;
			});
		}
		case SET_PATIENT: {
			const { patient } = action.payload;

			return produce(state, draft => {
				draft.patient = patient;
			});
		}
		case SET_AUDIPHONE: {
			const {
				type,
				hearinginstrument,
				data,
				hearinginstrumentOther
			} = action.payload;

			if (type === "left") {
				return produce(state, draft => {
					draft.hearingDeviceLeft = hearinginstrument;
					draft.hearingDeviceSettingLeft = data?.left;
				});
			} else if (type === "right") {
				return produce(state, draft => {
					draft.hearingDeviceRight = hearinginstrument;
					draft.hearingDeviceSettingRight = data?.right;
				});
			} else {
				return produce(state, draft => {
					draft.hearingDeviceLeft = hearinginstrumentOther ?? hearinginstrument;
					draft.hearingDeviceSettingLeft = data?.left;
					draft.hearingDeviceRight = hearinginstrument;
					draft.hearingDeviceSettingRight = data?.right;
				});
			}
			break;
		}
		case SET_AUDIPHONE_SETTING: {
			const { type, setting } = action.payload;
			if (type === "left") {
				return produce(state, draft => {
					draft.hearingDeviceSettingLeft = setting;
				});
			} else if (type === "right") {
				return produce(state, draft => {
					draft.hearingDeviceSettingRight = setting;
				});
			} else if (type === "all") {
				return produce(state, draft => {
					draft.hearingDeviceSettingLeft = setting;
					draft.hearingDeviceSettingRight = setting;
				});
			}
			break;
		}
		case SET_ACOUSTICS_CHART_DATA: {
			const { type, chartIndex, lineIndex, points } = action.payload;
			if (type === "left") {
				return produce(state, draft => {
					draft.acousticsChartDataLeft[chartIndex][lineIndex].points = points;
				});
			} else if (type === "right") {
				return produce(state, draft => {
					draft.acousticsChartDataRight[chartIndex][lineIndex].points = points;
				});
			}
			break;
		}
		case SET_ALL_CHART: {
			const { type, data = [], data2 = [], ids = [] } = action.payload;
			if (type === "left") {
				return produce(state, draft => {
					draft.acousticsChartDataLeft = data;
				});
			} else if (type === "right") {
				return produce(state, draft => {
					draft.acousticsChartDataRight = data;
				});
			} else {
				return produce(state, draft => {
					draft.acousticsChartDataLeft = data2;
					draft.acousticsChartDataRight = data;
					draft.audiogramIds = ids;
				});
			}
		}
		case SET_ACOUSTICS_CHART_SETTING: {
			const { type, chartIndex, setting } = action.payload;
			if (type === "left") {
				return produce(state, draft => {
					draft.acousticsChartSettingLeft[chartIndex] = setting;
				});
			} else if (type === "right") {
				return produce(state, draft => {
					draft.acousticsChartSettingRight[chartIndex] = setting;
				});
			} else if (type === "all") {
				return produce(state, draft => {
					draft.acousticsChartSettingLeft[chartIndex] = setting;
					draft.acousticsChartSettingRight[chartIndex] = setting;
				});
			}
			break;
		}
		case SET_ALL_ACOUSTICS_CHART_SETTING: {
			const { type, index, setting, setting2 } = action.payload;
			switch (type) {
				case "left":
					return produce(state, draft => {
						draft.acousticsChartDataLeft[index] = setting2;
					});
				case "right":
					return produce(state, draft => {
						draft.acousticsChartDataRight[index] = setting;
					});
				case "all":
				default:
					return produce(state, draft => {
						draft.acousticsChartDataRight[index] = setting;
						draft.acousticsChartDataLeft[index] = setting2;
					});
			}
		}
		case SET_ADJUST_TYPE: {
			const { type } = action.payload;
			return produce(state, draft => {
				draft.hearinginstrumentAdjustmentData.type = type;
			});
		}
		case SET_SHOW_GAIN_THRESHOLD: {
			const { show } = action.payload;
			return produce(state, draft => {
				draft.hearinginstrumentAdjustmentData.Gain.show = show;
			});
		}
		case SET_ADJUST_TYPE_IN_TYPE: {
			const { type, inType } = action.payload;
			return produce(state, draft => {
				draft.hearinginstrumentAdjustmentData[type].type = inType;
			});
		}
		case SET_IO_RATE: {
			const rate = action.payload;
			return produce(state, draft => {
				draft.hearinginstrumentAdjustmentData.InputOutput.rate = rate;
			});
		}
		case SET_GAIN_CHART_POINTS: {
			const { leftData, rightData } = action.payload;
			return produce(state, draft => {
				const gainType = draft.hearinginstrumentAdjustmentData.Gain.type;
				if (rightData)
					draft.hearinginstrumentAdjustmentData.Gain[
						gainType
					].rightData = rightData;
				if (leftData)
					draft.hearinginstrumentAdjustmentData.Gain[
						gainType
					].leftData = leftData;
			});
		}
		case SET_OPEN_SOUND_RECOVER_2: {
			const { isOpen, type } = action.payload;
			return produce(state, draft => {
				if (type === "left") {
					draft.hearinginstrumentFineAdjustmentData.left.openSoundRecover2 = isOpen;
				} else if (type === "right") {
					draft.hearinginstrumentFineAdjustmentData.right.openSoundRecover2 = isOpen;
				} else {
					draft.hearinginstrumentFineAdjustmentData.left.openSoundRecover2 = isOpen;
					draft.hearinginstrumentFineAdjustmentData.right.openSoundRecover2 = isOpen;
				}
			});
		}
		case SET_OPEN_SOUND_RECOVER_RATE_RANGE: {
			const { type, range } = action.payload;
			return produce(state, draft => {
				if (type === "left") {
					draft.hearinginstrumentFineAdjustmentData.left.range = range;
				} else if (type === "right") {
					draft.hearinginstrumentFineAdjustmentData.right.range = range;
				} else {
					draft.hearinginstrumentFineAdjustmentData.left.range = range;
					draft.hearinginstrumentFineAdjustmentData.right.range = range;
				}
			});
		}
		case SET_USER_NOISE_GENERATOR: {
			const { type, useNoiseGenerator } = action.payload;
			return produce(state, draft => {
				if (type === "left") {
					draft.hearinginstrumentFineAdjustmentData.left.useNoiseGenerator = useNoiseGenerator;
				} else if (type === "right") {
					draft.hearinginstrumentFineAdjustmentData.right.useNoiseGenerator = useNoiseGenerator;
				} else {
					draft.hearinginstrumentFineAdjustmentData.left.useNoiseGenerator = useNoiseGenerator;
					draft.hearinginstrumentFineAdjustmentData.right.useNoiseGenerator = useNoiseGenerator;
				}
			});
		}
		case SET_FEEDBACK_REALEARTEST_OVERTUNING: {
			const { type, overtuning } = action.payload;
			return produce(state, draft => {
				if (type === "left") {
					draft.feedbackRealEarTest.left.overtuning += overtuning;
				} else if (type === "right") {
					draft.feedbackRealEarTest.right.overtuning += overtuning;
				} else {
					draft.feedbackRealEarTest.left.overtuning += overtuning;
					draft.feedbackRealEarTest.right.overtuning += overtuning;
				}
			});
		}
		case SET_HI_CONFIGURATION: {
			const { data } = action.payload;
			return produce(state, draft => {
				draft.hiConfiguration = data;
			});
		}
		case SET_HI_DETAIL: {
			const { data } = action.payload;
			return produce(state, draft => {
				draft.hiDetail = data;
			});
		}
		case SET_HI_IMAGE: {
			const { left, right } = action.payload;
			return produce(state, draft => {
				if (draft.hearingDeviceSettingLeft && left) {
					draft.hearingDeviceSettingLeft.picture.imageUrl = left.imageUrl;
					draft.hearingDeviceSettingLeft.picture.coupling = left.coupling;
					draft.hearingDeviceSettingLeft.hiFittingRanges = left.hiFittingRanges;
				}
				if (draft.hearingDeviceSettingRight && right) {
					draft.hearingDeviceSettingRight.picture.imageUrl = right.imageUrl;
					draft.hearingDeviceSettingRight.picture.coupling = right.coupling;
					draft.hearingDeviceSettingRight.hiFittingRanges = right.hiFittingRanges;
				}
			});
		}
		case SET_DETAIL_COLOR_VALUE: {
			const { side, key, value } = action.payload;
			return produce(state, draft => {
				if (side === "left") {
					const datails = draft.hiDetail.left.find(d => d.key === key);
					if (datails) datails.currentValue = value;
				} else if (side === "right") {
					const datails = draft.hiDetail.right.find(d => d.key === key);
					if (datails) datails.currentValue = value;
				} else {
					const leftDetails = draft.hiDetail.left.find(d => d.key === key);
					if (leftDetails) leftDetails.currentValue = value;
					const rightDetails = draft.hiDetail.right.find(d => d.key === key);
					if (rightDetails) rightDetails.currentValue = value;
				}
			});
		}
		case CLEAR_PATIENT: {
			const { side } = action.payload;
			if (side === "left") {
				return produce(state, draft => {
					draft.hearingDeviceLeft = null;
					draft.hearingDeviceSettingLeft = null;
				});
			} else if (side === "right") {
				return produce(state, draft => {
					draft.hearingDeviceRight = null;
					draft.hearingDeviceSettingRight = null;
				});
			} else
				return produce(state, draft => {
					draft.hearingDeviceLeft = null;
					draft.hearingDeviceRight = null;
					draft.hearingDeviceSettingLeft = null;
					draft.hearingDeviceSettingRight = null;
				});
		}
		default: {
			return state;
		}
	}
};

export default patientReducer;
